import {styled, Box} from '@mui/material'
import { colors } from '@headless-shell/shared-styles';


export const LoginBannerContainer = styled(Box)(({ theme, bgColor }) => ({
  width: '100%',
  position: 'fixed',
  top: 0,
  paddingTop: '0.5rem',
  background: bgColor || colors.blue.light,
  zIndex: 6,
   [theme.breakpoints.up('sm')]: {
   paddingTop: '1rem',
     height: '3rem',
  },
}));


export const BannerTextContainer = styled(Box)(({ theme, textColor }) => ({
  [theme.breakpoints.up('sm')]: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  fontSize: '1rem',
  textAlign: 'center',
  ...(textColor && { color: textColor }),
  },
 [theme.breakpoints.down('sm')]: {
  textAlign: 'center',
  padding: '0.4rem 1rem',
  fontSize: '0.90rem',
  ...(textColor && { color: textColor }),
}
}));